import { render, staticRenderFns } from "./Autenticacao.vue?vue&type=template&id=c3632d54&scoped=true&"
import script from "./Autenticacao.vue?vue&type=script&lang=js&"
export * from "./Autenticacao.vue?vue&type=script&lang=js&"
import style0 from "./Autenticacao.vue?vue&type=style&index=0&id=c3632d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3632d54",
  null
  
)

export default component.exports